import type { CategoryInsights } from "@/api/categoryService";
import { Link } from "@/components/Link";
import { toArabicNumerals } from "@/lib/arabicNumerals";
import { usePostHogTracking } from "@/hooks/usePostHogTracking";

// Active categories that share the most published stores with this one (computed, not curated).
// Sits right under the header as one row of chips (Ali, 2026-10-10: "needs to be more at the
// top"); the row scrolls sideways on phones.
export default function CategoryRelated({
  insights,
  categorySlug,
}: {
  insights: CategoryInsights | null;
  categorySlug: string;
}) {
  const { trackNavigation } = usePostHogTracking();
  const related = insights?.relatedCategories ?? [];
  if (related.length === 0) return null;

  return (
    <nav className="catpage-related" aria-label="فئات مرتبطة">
      <span className="catpage-related-label">فئات مرتبطة</span>
      <div className="catpage-related-row">
        {related.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            onClick={() => trackNavigation.categoryInsightClicked(categorySlug, "related_category", cat.slug)}
            className="catpage-chip"
          >
            <b>{cat.titleAr}</b>
            <span>{`${toArabicNumerals(cat.sharedStores)} متجر مشترك`}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
